import { Box, Chip, Table, TableBody, TableHead, TableRow, IconButton, Tooltip, Typography } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../common/components';
import { SUMMARY_COLUMNS } from '../constants/anniversaryPlanConstants';

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === 0) return '-';
  return `$${Number(value).toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatValue = (key, value) => {
  if (value === null || value === undefined) return '-';
  if (
    key === 'total_paid' ||
    key === 'last_payment_amount' ||
    key === 'overdue_amount' ||
    key === 'pending_amount'
  ) {
    return formatCurrency(value);
  }
  if (key === 'anniversary_agreement_date') {
    return value;
  }
  if (key === 'last_payment_date') {
    return value.split('T')[0];
  }
  return value;
};

const renderSubscribers = (subscribers) => {
  const subscribersArray = Array.isArray(subscribers) ? subscribers.filter(Boolean) : [];

  if (subscribersArray.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Sin asignar
      </Typography>
    );
  }

  const firstSubscriber = subscribersArray[0];
  if (subscribersArray.length === 1) {
    return <Typography variant="body2">{firstSubscriber}</Typography>;
  }

  const extraCount = subscribersArray.length - 1;
  const allNames = subscribersArray.join('\n');

  return (
    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{allNames}</div>} arrow>
      <Typography
        variant="body2"
        sx={{ cursor: 'help', display: 'inline-flex', alignItems: 'center' }}
      >
        {firstSubscriber}
        <Box
          component="span"
          sx={{
            ml: 1,
            bgcolor: 'primary.main',
            color: 'white',
            borderRadius: '12px',
            px: 0.8,
            fontSize: '0.75rem',
            fontWeight: 'bold',
          }}
        >
          +{extraCount}
        </Box>
      </Typography>
    </Tooltip>
  );
};

const AnniversaryPlanSummaryTable = ({ rows, isLoading, onRowClick }) => {
  return (
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            {SUMMARY_COLUMNS.map((col) => (
              <HeadTableCell key={col.key}>{col.label}</HeadTableCell>
            ))}
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : rows.length === 0 ? (
            <NoDataSkeleton colSpan={SUMMARY_COLUMNS.length + 1} />
          ) : (
            rows.map((row, idx) => (
              <TableRow key={row.contract_number ?? idx} hover>
                {SUMMARY_COLUMNS.map((col) => (
                  <RowTableCell key={col.key}>
                    {col.key === 'subscribers' ? (
                      renderSubscribers(row.subscribers)
                    ) : col.key === 'anniversary_agreement_date' &&
                      row.anniversary_missing_agreement_date ? (
                      <Chip
                        label="Falta acuerdo"
                        size="small"
                        color="error"
                        variant="outlined"
                        sx={{ fontSize: 10, height: 20 }}
                      />
                    ) : col.key === 'contract_number' && row.archive_status ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {row.contract_number}
                        <Chip
                          label={row.archive_status}
                          size="small"
                          color={row.archive_status === 'Archivado' ? 'warning' : 'error'}
                          variant="outlined"
                          sx={{ fontSize: 10, height: 18 }}
                        />
                      </Box>
                    ) : (
                      formatValue(col.key, row[col.key])
                    )}
                  </RowTableCell>
                ))}
                <RowTableCell>
                  <Tooltip title="Ver detalle">
                    <IconButton size="small" onClick={() => onRowClick(row)}>
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default AnniversaryPlanSummaryTable;
